import React from 'react';
import { connect } from 'react-redux';

import { getExploreTalentsDataFetchState, getExploreTalentsProfiles, getLanguage, getTotalTalentsCount } from 'reducers';

import ExploreTalentsContent from './ExploreTalentsContent';

const ExploreTalentsContentRedux = ({
    talents,
    totalTalentsCount,
    dataFetchState,
    selectedLanguage,
    ...props
}) => (
    <ExploreTalentsContent
        talents={talents}
        totalTalentsCount={totalTalentsCount}
        dataFetchState={dataFetchState}
        selectedLanguage={selectedLanguage}
        {...props}
    />
);

const mapStateToProps = (state) => ({
    talents: getExploreTalentsProfiles(state),
    totalTalentsCount: getTotalTalentsCount(state),
    dataFetchState: getExploreTalentsDataFetchState(state),
    selectedLanguage: getLanguage(state)
});

export default connect(mapStateToProps, null)(ExploreTalentsContentRedux);
